<div class="game-panel" *ngIf="game">
  <div class="nav">
    <a [routerLink]="gameStatisticRoute" routerLinkActive="active">Статистика</a>
    <a [routerLink]="gameProtocolRoute" routerLinkActive="active">Протокол</a>
    <a [routerLink]="gameTimelineRoute" routerLinkActive="active">Ход игры</a>
    <a *ngIf="game.mediaCount" [routerLink]="gameMediaRoute" routerLinkActive="active">Медиа</a>
    <a *ngIf="game.mediaLiveCount" [routerLink]="gameLiveRoute" routerLinkActive="active">Трансляция</a>

  </div>
  <div class="game-content">
    <div class="download">
      <mtg-basketball-game-documents
        *ngIf="league.sport.isBasketball()"
        [game]="game"
      ></mtg-basketball-game-documents>
      <mtg-hockey-game-documents
        *ngIf="league.sport.isHockey()"
        [game]="game"
      ></mtg-hockey-game-documents>
      <mtg-volleyball-game-documents
        *ngIf="league.sport.isVolleyball()"
        [game]="game"
      ></mtg-volleyball-game-documents>
      <mtg-football-game-documents
        *ngIf="league.sport.isFootball()"
        [game]="game"
      ></mtg-football-game-documents>
      <mtg-handball-game-documents
        *ngIf="league.sport.isHandball()"
        [game]="game"
      ></mtg-handball-game-documents>
      <mtg-rugby-game-documents
        *ngIf="league.sport.isRugby()"
        [game]="game"
      ></mtg-rugby-game-documents>
    </div>

    <mtg-game-header
      [game]="game"
      [teamRoute]="teamRoute"
      [competitorTeamRoute]="competitorTeamRoute"
    ></mtg-game-header>
    <router-outlet></router-outlet>
  </div>
</div>
